document.querySelectorAll('[data-pdp-parallax]').forEach(function (el) {
  if (!window.matchMedia('(hover: hover)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var frame = null;

  el.addEventListener('pointermove', function (event) {
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = null;
      var box = el.getBoundingClientRect();
      el.style.setProperty('--px', ((event.clientX - box.left) / box.width - 0.5).toFixed(3));
      el.style.setProperty('--py', ((event.clientY - box.top) / box.height - 0.5).toFixed(3));
    });
  });

  el.addEventListener('pointerleave', function () {
    el.style.setProperty('--px', '0');
    el.style.setProperty('--py', '0');
  });
});
